<template>
  <div class="resume-module-manager">
    <div class="module-title">
      <div class="m-l">
        <img class="icon" src="../../assets/img/bookmark-one.png" alt="">
        <div class="title">学术经历</div>
      </div>
      <div class="m-r">
        <img @click="handleAdd" class="add-icon" src="../../assets/img/Add.png" alt="">
      </div>
    </div>
    <div class="data-wrap" v-if="dataList.length && !detailShow">
      <div class="wrap-item data-item-wrap" v-for="item in dataList" :key="item.id">
        <div class="action">
          <img @click="handleEdit(item)" class="edit-icon" src="../../assets/img/edit.png" alt="">
          <img @click="handleDelete(item.id)" class="delete-icon" src="../../assets/img/delete.png" alt="">
        </div>
        <div class="content-wrap">
          <div class="main-info">
            <div class="name">{{ item.project_name || '未填写' }}</div>
            <div class="period">
              <div class="start-date">{{ formatDate(item.start_time) }}</div> <span
                v-if="item.end_time" style="margin: 0 6px;">-</span>
              <div class="end-date" v-if="item.end_time">{{
                formatDate(item.end_time) }}</div>
            </div>
          </div>
          <div class="sub-info">
            <div class="sub-item">
              担任职务：{{ item.position || '未填写' }}
            </div>
            <div class="sub-item">
              经历描述：{{ item.description || '未填写' }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="data-form-wrap" v-if="detailShow">
      <div class="title">{{ form.id ? '编辑学术经历' : '添加学术经历' }}</div>
      <el-form :model="form" ref="formRef" :rules="rules" label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="项目名称" prop="project_name">
              <el-input clearable class="w100" v-model="form.project_name" placeholder="请填写项目名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="担任职务" prop="position">
              <el-input clearable class="w100" v-model="form.position" placeholder="请填写担任职务"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="经历时间" prop="start_time">
              <div class="date-picker-wrap">
                <el-date-picker value-format="yyyy-MM-dd" clearable prefix-icon="''" style="width: 45%;"
                  v-model="form.start_time" type="month" placeholder="开始时间"></el-date-picker>
                -
                <el-date-picker value-format="yyyy-MM-dd" clearable prefix-icon="''" style="width: 45%;"
                  v-model="form.end_time" type="month" placeholder="结束时间"></el-date-picker>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="经历描述" prop="description">
              <el-input clearable class="w100" type="textarea" :rows="5" v-model="form.description" placeholder="请填写经历描述"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="footer">
        <el-button size="small" class="cancel-btn" @click="handleCancel">取消</el-button>
        <el-button size="small" class="save-btn" type="primary" @click="handleSave">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Education',
  props: {
    dataList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      detailShow: false,
      form: {
        id: '',
        project_name: '',
        position: '',
        start_time: '',
        end_time: '',
        description: '',
      },
      rules: {
        project_name: [{ required: true, message: '请填写项目名称', trigger: 'blur' }],
        position: [{ required: true, message: '请填写职位', trigger: 'blur' }],
        start_time: [
          { required: true, message: '请选择开始时间', trigger: 'change' },
          { validator: this.validateDate, trigger: 'change' }
        ],
      }
    }
  },
  methods: {
    validateDate(rule, value, callback) {
      if (!this.form.end_time) {
        callback(new Error('请选择结束时间'));
        return;
      }
      if (this.form.start_time && this.form.end_time && this.form.start_time > this.form.end_time) {
        callback(new Error('开始时间不能大于结束时间'));
      } else {
        callback();
      }
    },
    formatDate(date) {
      if (!date) return '--'
      // 只返回年月日部分
      return date.split(' ')[0] || date
    },
    handleAdd() {
      this.detailShow = true;
      this.form = {
        id: '',
        project_name: '',
        position: '',
        start_time: '',
        end_time: '',
        description: '',
      }
    },
    handleEdit(item) {
      this.detailShow = true;
      this.form = item;
    },
    handleDelete(id) {
      this.$confirm('确定删除该学术经历吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$emit('delete', id);
      });
    },
    handleCancel() {
      this.$confirm('确定取消编辑吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.detailShow = false;
        this.$refs.formRef.resetFields();
      });
    },
    handleSave() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          const formatDate = (dateStr) => {
          const date = new Date(dateStr)
          if (isNaN(date.getTime())) return dateStr
          const year = date.getFullYear()
          const month = String(date.getMonth() + 1).padStart(2, '0')
          const day = String(date.getDate()).padStart(2, '0')
          return `${year}-${month}-${day} 00:00:00.000`
        }
          this.$emit('save', {
            ...this.form,
            start_time: formatDate(this.form.start_time),
            end_time: formatDate(this.form.end_time)
          });
          this.detailShow = false;
          this.$refs.formRef.resetFields();
        }
      });
    }
  }
}
</script>

<style scoped lang="scss">
.w100 {
  width: 100% !important;
}

.resume-module-manager {
  padding: 18px 0 18px 12px;
  border-bottom: 1px dashed #B16EF9;

  .module-title {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .m-l {
      display: flex;
      align-items: center;

      .icon {
        width: 26px;
        height: 26px;
        margin-right: 12px;
      }

      .title {
        font-size: 20px;
        font-weight: 600;
        color: #656587;
      }
    }

    .m-r {
      cursor: pointer;
      display: flex;
      width: 24px;
      height: 24px;

      .add-icon {
        width: 100%;
        height: 100%;
      }

      &:hover {
        opacity: 0.8;
      }
    }
  }

  .data-wrap {
    margin-top: 16px;

    .wrap-item {
      cursor: pointer;
      padding-left: 36px;
      padding-top: 8px;
      padding-bottom: 8px;
      border-radius: 12px;

      &:hover {
        background: linear-gradient(0deg, rgba(152, 152, 152, 0.03), rgba(152, 152, 152, 0.03)), #FFFFFF;
      }

      .action {
        display: flex;
        justify-content: flex-end;
        padding-right: 5px;

        .delete-icon,
        .edit-icon {
          cursor: pointer;
          width: 16px;

          &:hover {
            opacity: .8;
          }
        }

        .edit-icon {
          margin-right: 8px;
        }
      }

      .content-wrap {
        .main-info {
            display: flex;
            align-items: center;
            flex-wrap: wrap;

            .name {
              min-width: 200px;
              margin-right: 32px;
              font-size: 20px;
              font-weight: 600;
              color: #000000;
              margin-bottom: 8px;
            }

            .period {
              display: flex;
              align-items: center;
              font-size: 16px;
              color: #656587;
              margin-bottom: 8px;
            }
          }

          .sub-info {
            display: flex;
            align-items: center;
            flex-wrap: wrap;

            .sub-item {
              width: 100%;
              font-size: 14px;
              color: #656587;
              line-height: 20px;
              margin-right: 20px;
            }
          }
      }
    }
  }

  .data-form-wrap {
    margin-top: 16px;
    padding: 16px 16px 16px 36px;
    border-radius: 12px;
    // background: #fcfcfc;
    background: linear-gradient(0deg, rgba(152, 152, 152, 0.03), rgba(152, 152, 152, 0.03)), #FFFFFF;

    .title {
      margin-bottom: 16px;
      font-size: 16px;
      font-weight: 600;
      color: #656587;
    }

    .date-picker-wrap {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .footer {
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>